import React, { useState, useRef } from 'react';
import { useMount } from 'react-use';
import { getAiAnalysis } from '@/services/scoreServices';
import styles from './AiAnalysis.module.scss';

interface AiAnalysisProps {
  nightmareId: string;
}

function AiAnalysis({ nightmareId }: AiAnalysisProps) {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [expanded, setExpanded] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);

  useMount(async () => {
    const result: any = await getAiAnalysis(nightmareId);
    if (result && result.content) {
      setContent(result.content);
    }
    setLoading(false);
  });

  if (loading || !content) return null;

  const renderMarkdown = (text: string) => {
    const html = text
      // Headings
      .replace(/^### (.+)$/gm, '<h3>$1</h3>')
      .replace(/^## (.+)$/gm, '<h2>$1</h2>')
      .replace(/^# (.+)$/gm, '<h1>$1</h1>')
      // Bold
      .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
      // Newlines to <br>
      .replace(/\n/g, '<br/>');
    return html;
  };

  return (
    <div className={styles.container}>
      <div className={styles.header} onClick={() => setExpanded(!expanded)}>
        <span className={styles.bar} />
        <span className={styles.title}>球掌门小诸葛</span>
        <span className={styles.toggle}>
          {expanded ? '收起' : '展开全文'}
          <i className={`iconfont iconcaret-down font12 ml5 ${expanded ? styles.arrowUp : ''}`} />
        </span>
      </div>
      <div className={styles.body} style={{ maxHeight: expanded ? contentRef.current?.scrollHeight : 100 }}>
        <div className={styles.content} ref={contentRef}>
          <div dangerouslySetInnerHTML={{ __html: renderMarkdown(content) }} />
        </div>
        {!expanded && <div className={styles.fade} />}
      </div>
      {expanded && (
        <div className={styles.disclaimer}>
          小诸葛提示：以上内容不构成投注建议，仅供足球赛事者分析参考，数据梳理。
        </div>
      )}
    </div>
  );
}

export default AiAnalysis;
